import { render, staticRenderFns } from "./systemContent.vue?vue&type=template&id=71735817&"
import script from "./systemContent.vue?vue&type=script&lang=js&"
export * from "./systemContent.vue?vue&type=script&lang=js&"
import style0 from "./systemContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports